<template>
  <v-container grid-list-md fluid>
    <!-- // Componente para exportar o relatório de LCDPR -->
    <p-export-lcdpr ref="lcdpr"></p-export-lcdpr>
    <!-- // Componente para gerar o relatório de Caixa Geral -->
    <p-export-caixa-geral ref="caixaGeral"></p-export-caixa-geral>
    <!-- // Componente para gerar o relatório de Conferencia -->
    <p-relatorio-conferencia ref="conferencia"></p-relatorio-conferencia>

    <div class="text-xs-center">
      <v-dialog v-model="dialog_settings" scrollable width="800">
        <v-card>
          <v-toolbar color="primary">
            <v-toolbar-title class="white--text">Importação do Arquivo DBK</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn dark icon @click="dialog_settings = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-subheader>Escolha um arquivo para ser importado:</v-subheader>
            <div>
              <input
                ref="uploader"
                type="file"
                accept=".dbk, .dec"
                id="file"
                @change="onFileChanged"
              />
            </div>
            <br />
            <v-divider></v-divider>
            <v-subheader>Selecione as abas que gostaria de importar:</v-subheader>
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-checkbox
                    v-model="checkboxes['bem_direito']"
                    label="Bem e Direito"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="checkboxes['bem_atividade_rural']"
                    label="Bem da Atividade Rural"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="checkboxes['divida_onus_real']"
                    label="Dívida e Ônus Real"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="checkboxes['divida_atividade_rural']"
                    label="Dívida da Atividade Rural"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="checkboxes['rendimento_tributavel_pj']"
                    label="Rendimento Tributável Recebido de PJ"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-checkbox
                    v-model="checkboxes['rendimento_isento_nao_tributavel']"
                    label="Rendimento Isento Não Tributável"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="checkboxes['rendimento_tributacao_exclusiva']"
                    label="Rendimento Tributação Exclusiva"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="checkboxes['pagamento_efetuado']"
                    label="Pagamento Efetuado"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="checkboxes['movimentacao_financeira']"
                    label="Movimentação Financeira"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" :disabled="!selectedFile" @click="importDBK(false)">
              Confirmar
            </v-btn>
            <v-btn
              color="primary"
              flat
              @click="
                () => {
                  dialog_settings = false;
                }
              "
            >
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <div class="text-xs-center">
      <v-dialog v-model="dialog_log" width="500">
        <v-card>
          <v-card-text>
            O sistema encontrou algumas inconsistências durante o processo de geração das
            informações.
            <br />
            <br />
            Deseja prosseguir e gerar o arquivo DBK mesmo assim, ou prefere visualizar o arquivo de
            log para verificar as inconsistências encontradas?
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="downloadDBK">Gerar DBK</v-btn>
            <v-btn color="primary" flat @click="viewLOG">Visualizar Arquivo de Log</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <div class="text-xs-center">
      <v-dialog v-model="dialogLogImportacao" width="500">
        <v-card>
          <v-card-text>
            Foi encontrado algumas inconsistências durante o processo de importação das informações.
            <br />
            <br />
            Deseja importar as informações e visualizar o log, ou prefere apenas visualizar o log
            para verificar as inconsistências encontradas?
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="importDBK(true)">Importar DBK</v-btn>
            <v-btn color="primary" flat @click="visualizeFileImportError()">
              Apenas Visualizar Log
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <!--Change Company-->
    <v-dialog v-model="changeCompany.dialog" max-width="700px" persistent>
      <v-card>
        <v-card-text>
          <v-container grid-list-md fluid>
            <v-layout wrap justify-center align-center>
              <v-flex xs12>
                <span class="display-1">Alterar Empresa Responsável</span>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :label="translate('table.' + entity + '.field.empresa_id')"
                  :items="changeCompany.empresas"
                  item-text="id_texto"
                  item-value="id"
                  v-model="editedItem.empresa_id"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-btn class="mx-1" color="primary darken-2" @click.native="confirmChangeCompany">
                  Confirmar
                </v-btn>
                <v-btn class="mx-1" @click.native="toogleCompanyDialog">Cancelar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--Index-->
    <v-layout v-if="view === 1" wrap justify-center align-center>
      <v-flex xs12 sm8>
        <span class="display-1">
          {{
            this.translate("system.title.consult") +
            this.translate("table." + this.entity + ".title")[1]
          }}
        </span>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>

      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          class="elevation-1"
          :rows-per-page-items="[100, 50, 25, { text: 'Todos', value: -1 }]"
          rows-per-page-text="Registros por página"
          no-data-text="Não existem registros"
          no-results-text="Nenhum registro encontrado"
        >
          <template slot="items" slot-scope="props">
            <td
              v-if="$auth.user().acesso_interno == 'dev'"
              @click="showMenu($event, props.item)"
              style="cursor: pointer"
            >
              {{ props.item.id_texto }}
            </td>
            <td v-else>{{ props.item.id_texto }}</td>
            <td>{{ props.item.nome_abreviado }}</td>
            <td>{{ props.item.cpf_cnpj | formatCpfCnpj }}</td>
            <td>{{ props.item.rg_ie }}</td>
            <td>
              <v-checkbox
                :disabled="!props.item.isOwner || !hasAccess(entity, 'enabled')"
                v-model="props.item.ativo"
                color="primary"
                @click.native="editValue(entity, props.item.id, props.item)"
              ></v-checkbox>
            </td>
            <td align="center">
              <v-btn
                icon
                class="mx-0"
                @click="editItem(props.item)"
                :disabled="!hasAccess(entity, 'update')"
              >
                <v-icon color="teal">{{ props.item.isOwner ? "edit" : "remove_red_eye" }}</v-icon>
              </v-btn>
              <v-btn
                icon
                class="mx-0"
                @click="deleteItem(props.item, props.item.id, true)"
                :disabled="!hasAccess(entity, 'delete')"
                v-if="props.item.isOwner"
              >
                <v-icon color="pink">delete</v-icon>
              </v-btn>
              <span v-if="!props.item.isOwner">
                <v-tooltip top v-if="isUnlocked(props.item)">
                  <v-btn slot="activator" icon class="mx-0" @click="liberaAcesso(props.item)">
                    <v-icon color="green">lock_open</v-icon>
                  </v-btn>
                  <span>Acesso Liberado</span>
                </v-tooltip>
                <v-tooltip top v-if="!isUnlocked(props.item)">
                  <v-btn slot="activator" icon class="mx-0" @click="liberaAcesso(props.item)">
                    <v-icon color="red">lock</v-icon>
                  </v-btn>
                  <span>Acesso Bloqueado</span>
                </v-tooltip>
              </span>
              <v-tooltip top>
                <router-link
                  slot="activator"
                  :to="{
                    name: 'Contribuinte',
                    params: {
                      pessoa: {
                        id: props.item.id,
                        id_texto: props.item.id_texto,
                      },
                    },
                  }"
                  tag="button"
                >
                  <v-btn
                    icon
                    class="mx-0"
                    v-if="
                      props.item.isOwner &&
                      ($auth.user().acesso_interno == 'dev' ||
                        $auth.user().acesso_interno == 'admin')
                    "
                  >
                    <v-icon color="green">attach_money</v-icon>
                  </v-btn>
                </router-link>
                <span>Contribuinte</span>
              </v-tooltip>
              <v-tooltip top>
                <v-btn
                  slot="activator"
                  icon
                  class="mx-0"
                  @click="toogleCompanyDialog(props.item)"
                  v-if="
                    props.item.isOwner &&
                    ($auth.user().acesso_interno == 'dev' || $auth.user().acesso_interno == 'admin')
                  "
                >
                  <v-icon color="indigo">sync</v-icon>
                </v-btn>
                <span>Alterar Empresa Responsável</span>
              </v-tooltip>

              <v-tooltip top>
                <v-btn
                  slot="activator"
                  icon
                  class="mx-0"
                  @click="openDialogDBK(props.item, $event)"
                  :disabled="!hasAccess(entity, 'dbk')"
                >
                  <v-icon color="purple">share</v-icon>
                </v-btn>
                <span>Exportar DBK</span>
              </v-tooltip>

              <v-tooltip top>
                <v-btn
                  slot="activator"
                  icon
                  class="mx-0"
                  @click="clickLCDPR(props.item.id, props.item.id_texto)"
                >
                  <v-icon color="blue lighten-2">request_quote</v-icon>
                </v-btn>
                <span>Gerar LCDPR</span>
              </v-tooltip>

              <v-menu open-on-hover offset-y origin="center center" transition="scale-transition">
                <template v-slot:activator="{ on }">
                  <v-btn icon class="mx-0" v-on="on">
                    <v-icon color="orange">library_books</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile @click="clickCaixaGeral(props.item.id, props.item.id_texto)">
                    <v-list-tile-title>Relatório Caixa Geral</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="clickConferencia(props.item.id, props.item.id_texto)">
                    <v-list-tile-title>Relatório de Conferência</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
          </template>
          <template slot="pageText" slot-scope="props">
            {{ props.pageStart }} - {{ props.pageStop }} de
            {{ props.itemsLength }}
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <!--Create Edit-->
    <div v-else>
      <v-layout wrap justify-center align-center>
        <v-flex xs12 md6>
          <span class="display-1">{{ isBlocked() ? "Visualização de Pessoa" : formTitle }}</span>
        </v-flex>

        <v-spacer></v-spacer>

        <v-flex xs12 md3>
          <v-text-field
            :label="translate('table.' + entity + '.field.ultimo_numero_recibo')"
            v-model="editedItem.ultimo_numero_recibo"
            :mask="'##########'"
            name="ultimo_numero_recibo"
            counter
            maxlength="10"
            data-vv-validate-on="blur"
            v-validate="'min:10|max:10'"
            :error-messages="errors.collect('ultimo_numero_recibo')"
            :data-vv-as="translate('table.' + entity + '.field.ultimo_numero_recibo')"
          ></v-text-field>
          <!-- :value="maskedValue" -->
          <!-- @input="updateValue" -->
        </v-flex>
      </v-layout>
      <v-layout wrap justify-center align-center>
        <v-flex xs12 md3>
          <v-text-field
            :disabled="isBlocked()"
            name="id_texto"
            :label="name_label"
            v-model="editedItem.id_texto"
            counter
            maxlength="60"
            v-validate="'required'"
            data-vv-validate-on="blur"
            :error-messages="errors.collect('id_texto')"
            :data-vv-as="translate('table.' + entity + '.field.id_texto')"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field
            :disabled="isBlocked()"
            counter
            maxlength="38"
            name="nome_abreviado"
            label="Nome Abreviado"
            v-model="editedItem.nome_abreviado"
            v-validate="'required'"
            data-vv-validate-on="blur"
            :error-messages="errors.collect('nome_abreviado')"
            :data-vv-as="translate('table.' + entity + '.field.nome_abreviado')"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md3>
          <p-cpf-cnpj
            :disabled="isBlocked()"
            name="cpf_cnpj"
            v-model="editedItem.cpf_cnpj"
            v_validate="required"
            :data_vv_as="translate('table.' + entity + '.field.cpf_cnpj')"
            @blur="checkCpfExists"
          ></p-cpf-cnpj>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field
            :disabled="isBlocked()"
            name="rg_ie"
            :label="rgie_label"
            v-model="editedItem.rg_ie"
            return-masked-value
            counter
            maxlength="30"
          ></v-text-field>
          <!-- v-validate="'required'"
            data-vv-validate-on="blur"
            :error-messages="errors.collect('rg_ie')"
            :data-vv-as="translate('table.' + entity + '.field.rg_ie')" -->
        </v-flex>

        <v-flex xs12 md4>
          <p-date
            :disabled="isBlocked()"
            :label="translate('table.' + entity + '.field.nascimento')"
            v-model="editedItem.nascimento"
            name="nascimento"
            :v_validate="'required'"
            :as="translate('table.' + entity + '.field.nascimento')"
            errors_collect="nascimento"
          ></p-date>
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field
            :disabled="isBlocked()"
            name="titulo_eleitoral"
            :label="translate('table.' + entity + '.field.titulo_eleitoral')"
            v-model="editedItem.titulo_eleitoral"
            counter
            maxlength="13"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-switch
            :disabled="isBlocked()"
            color="primary"
            :label="translate('table.' + entity + '.field.doenca_deficiencia')"
            v-model="editedItem.doenca_deficiencia"
          ></v-switch>
        </v-flex>

        <v-flex xs12 md4>
          <v-switch
            :disabled="isBlocked()"
            color="primary"
            :label="translate('table.' + entity + '.field.possui_conjuge')"
            @change="clear_conjuge"
            v-model="editedItem.possui_conjuge"
          ></v-switch>
        </v-flex>
        <v-flex xs12 md8>
          <v-autocomplete
            :disabled="isBlocked()"
            v-if="editedItem.possui_conjuge"
            name="pessoa_id"
            :label="translate('table.' + entity + '.field.pessoa_id')"
            v-model="editedItem.pessoa_id"
            :items="conjuges"
            item-text="id_texto"
            item-value="id"
          ></v-autocomplete>
        </v-flex>

        <v-flex xs12 md6>
          <v-autocomplete
            name="natureza_ocupacao"
            :disabled="isBlocked()"
            :label="translate('table.' + entity + '.field.natureza_ocupacao')"
            v-model="editedItem.natureza_ocupacao"
            :items="translate('value.pessoa_natureza_ocupacao')"
            v-validate="'required'"
            :error-messages="errors.collect('natureza_ocupacao')"
            :data-vv-as="translate('table.' + entity + '.field.natureza_ocupacao')"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 md6>
          <v-autocomplete
            name="ocupacao_principal"
            :disabled="isBlocked()"
            :label="translate('table.' + entity + '.field.ocupacao_principal')"
            v-model="editedItem.ocupacao_principal"
            :items="translate('value.pessoa_ocupacao_principal')"
            v-validate="'required'"
            :error-messages="errors.collect('ocupacao_principal')"
            :data-vv-as="translate('table.' + entity + '.field.ocupacao_principal')"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 md4>
          <v-switch
            :disabled="isBlocked()"
            color="primary"
            :label="translate('table.' + entity + '.field.endereco_brasil')"
            v-model="editedItem.endereco_brasil"
          ></v-switch>
        </v-flex>
        <v-flex xs12 md8>
          <v-text-field
            :disabled="isBlocked()"
            v-if="!editedItem.endereco_brasil"
            name="cpf_procurador"
            :label="translate('table.' + entity + '.field.cpf_procurador')"
            v-model="editedItem.cpf_procurador"
          ></v-text-field>
        </v-flex>

        <v-flex xs12 md3>
          <v-switch
            :disabled="isBlocked()"
            color="primary"
            :label="translate('table.' + entity + '.field.mudanca')"
            v-model="editedItem.mudanca"
          ></v-switch>
        </v-flex>
        <v-flex xs12 md3 v-if="editedItem.endereco_brasil">
          <v-autocomplete
            name="tipo_logradouro"
            :disabled="isBlocked()"
            :label="translate('table.' + entity + '.field.tipo_logradouro')"
            v-model="editedItem.tipo_logradouro"
            :items="translate('value.pessoa_tipo_logradouro')"
            v-validate="'required'"
            :error-messages="errors.collect('tipo_logradouro')"
            :data-vv-as="translate('table.' + entity + '.field.tipo_logradouro')"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 :class="editedItem.endereco_brasil ? 'md4' : 'md7'">
          <v-text-field
            :disabled="isBlocked()"
            name="endereco"
            :label="translate('table.' + entity + '.field.endereco')"
            v-model="editedItem.endereco"
            v-validate="'required'"
            :error-messages="errors.collect('endereco')"
            :data-vv-as="translate('table.' + entity + '.field.endereco')"
            counter
            maxlength="40"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md2>
          <v-text-field
            :disabled="isBlocked()"
            name="numero"
            :label="translate('table.' + entity + '.field.numero')"
            v-model="editedItem.numero"
            v-validate="'required'"
            :error-messages="errors.collect('numero')"
            :data-vv-as="translate('table.' + entity + '.field.numero')"
            counter
            maxlength="6"
          ></v-text-field>
        </v-flex>

        <v-flex xs12 md8>
          <v-text-field
            :disabled="isBlocked()"
            name="complemento"
            :label="translate('table.' + entity + '.field.complemento')"
            v-model="editedItem.complemento"
            counter
            maxlength="21"
          ></v-text-field>
          <!-- v-validate="'required'"
            :error-messages="errors.collect('complemento')"
            :data-vv-as="translate('table.' + entity + '.field.complemento')" -->
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field
            :disabled="isBlocked()"
            name="bairro"
            :label="translate('table.' + entity + '.field.bairro')"
            v-model="editedItem.bairro"
            v-validate="'required'"
            :error-messages="errors.collect('bairro')"
            :data-vv-as="translate('table.' + entity + '.field.bairro')"
            counter
            maxlength="19"
          ></v-text-field>
        </v-flex>

        <v-flex xs12 md9 v-if="editedItem.endereco_brasil">
          <v-autocomplete
            :disabled="isBlocked()"
            name="cidade_id"
            :label="translate('table.' + entity + '.field.cidade_id')"
            v-model="editedItem.cidade_id"
            :items="cidades"
            item-text="id_texto"
            item-value="id"
            v-validate="'required'"
            :error-messages="errors.collect('cidade_id')"
            :data-vv-as="translate('table.' + entity + '.field.cidade_id')"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 md3 v-if="!editedItem.endereco_brasil">
          <v-autocomplete
            :disabled="isBlocked()"
            name="pais_id"
            :label="translate('table.' + entity + '.field.pais_id')"
            v-model="editedItem.pais_id"
            :items="paises"
            item-text="id_texto"
            item-value="id"
            v-validate="'required'"
            :error-messages="errors.collect('pais_id')"
            :data-vv-as="translate('table.' + entity + '.field.pais_id')"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 md3 v-if="!editedItem.endereco_brasil">
          <v-autocomplete
            :disabled="isBlocked()"
            :label="translate('table.' + entity + '.field.codigo_ext')"
            v-model="editedItem.codigo_ext"
            :items="translate('value.pessoa_codigo_ext')"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 md3 v-if="!editedItem.endereco_brasil">
          <v-text-field
            :disabled="isBlocked()"
            name="cidade_ext"
            :label="translate('table.' + entity + '.field.cidade_ext')"
            v-model="editedItem.cidade_ext"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field
            :disabled="isBlocked()"
            name="cep"
            :label="translate('table.' + entity + '.field.cep')"
            v-model="editedItem.cep"
            v-validate="'required'"
            :error-messages="errors.collect('cep')"
            :data-vv-as="translate('table.' + entity + '.field.cep')"
            counter
            maxlength="9"
          ></v-text-field>
        </v-flex>

        <v-flex xs12 md1>
          <v-text-field
            :disabled="isBlocked()"
            name="ddd_ddi_telefone"
            :label="translate('table.' + entity + '.field.ddd_ddi_telefone')"
            v-model="editedItem.ddd_ddi_telefone"
            :mask="'##'"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field
            :disabled="isBlocked()"
            name="telefone"
            :label="translate('table.' + entity + '.field.telefone')"
            return-masked-value
            :mask="'####-####'"
            v-model="editedItem.telefone"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md1 v-if="editedItem.endereco_brasil">
          <v-text-field
            :disabled="isBlocked()"
            name="ddd_celular"
            :label="translate('table.' + entity + '.field.ddd_celular')"
            v-model="editedItem.ddd_celular"
            :mask="'##'"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md3 v-if="editedItem.endereco_brasil">
          <v-text-field
            :disabled="isBlocked()"
            name="celular"
            :label="translate('table.' + entity + '.field.celular')"
            :mask="'# ####-####'"
            :return-masked-value="true"
            v-model="editedItem.celular"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 :class="editedItem.endereco_brasil ? 'md4' : 'md8'">
          <v-text-field
            :disabled="isBlocked()"
            name="email"
            :label="translate('table.' + entity + '.field.email')"
            v-model="editedItem.email"
            counter
            maxlength="60"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-textarea
            :disabled="isBlocked()"
            name="observacao"
            :label="translate('table.' + entity + '.field.observacao')"
            v-model="editedItem.observacao"
            counter
            maxlength="190"
          ></v-textarea>
        </v-flex>
        <v-flex xs12>
          <v-switch
            :disabled="isBlocked() || !hasAccess(entity, 'enabled')"
            color="primary"
            :label="translate('table.' + entity + '.field.ativo')"
            v-model="editedItem.ativo"
          ></v-switch>
        </v-flex>
        <v-flex xs12>
          <v-tabs
            color="green lighten-4"
            v-model="tab"
            grow
            show-arrows
            class="elevation-1"
            v-if="view === 3"
          >
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab key="0">
              {{ this.translate("table.pessoa_contato.title")[1] }}
            </v-tab>
            <v-tab key="1">
              {{ this.translate("table.pessoa_dependente.title")[1] }}
            </v-tab>
            <v-tab key="2">
              {{ this.translate("table.pessoa_empresa.title")[1] }}
            </v-tab>
            <v-tabs-items touchless v-model="tab">
              <v-tab-item key="0">
                <v-card>
                  <v-card-text>
                    <contatos
                      :pessoa_id="editedItem.id"
                      :values="editedItem.contatos"
                      :pessoa="editedItem"
                    ></contatos>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item key="1">
                <v-card>
                  <v-card-text>
                    <pessoa-dependente
                      :pessoa_id="editedItem.id"
                      :values="editedItem.dependentes"
                      :pessoa="editedItem"
                    ></pessoa-dependente>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item key="2">
                <v-card>
                  <v-card-text>
                    <empresas
                      :pessoa="editedItem"
                      :values="editedItem.empresas"
                      :empresas="empresas"
                    ></empresas>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-flex>
      </v-layout>
    </div>

    <v-layout class="fab-container" v-if="view === 1" align-center>
      <v-speed-dial v-model="fab" open-on-hover>
        <v-btn
          v-model="fab"
          slot="activator"
          fab
          color="primary"
          dark
          @click="create"
          :disabled="!hasAccess(entity, 'create')"
        >
          <v-icon>{{ this.translate("system.button.add.icon") }}</v-icon>
        </v-btn>
      </v-speed-dial>

      <v-btn
        v-if="view === 3 && this.$auth.user().empresa_id == this.editedItem.empresa_id"
        color="primary"
        dark
        fab
        :disabled="saving"
        :loading="loadingCpf || saving"
        @click="save()"
      >
        <v-icon>{{ this.translate("system.button.done.icon") }}</v-icon>
      </v-btn>

      <v-btn slot="activator" fab small color="secondary" @click="openDialogSettings">
        <v-icon>{{ this.translate("system.button.import.icon") }}</v-icon>
      </v-btn>

      <v-btn fab small @click="close">
        <v-icon>{{ this.translate("system.button.close.icon") }}</v-icon>
      </v-btn>
    </v-layout>

    <v-layout v-else class="fab-container" align-center>
      <v-speed-dial v-if="view === 2" v-model="fab" open-on-hover>
        <v-btn v-model="fab" slot="activator" fab color="primary" dark :disabled="saving" :loading="loadingCpf || saving" @click="save()">
          <v-icon>{{ this.translate("system.button.add.icon") }}</v-icon>
          <v-icon>{{ this.translate("system.button.save.icon") }}</v-icon>
        </v-btn>

        <v-tooltip left>
          <v-btn slot="activator" fab small color="secondary" :disabled="saving" :loading="loadingCpf || saving" @click="saveNew()">
            <v-icon>{{ this.translate("system.button.save_new.icon") }}</v-icon>
          </v-btn>
          <span>{{ this.translate("system.button.save_new.title") }}</span>
        </v-tooltip>

        <v-tooltip left>
          <v-btn slot="activator" fab small color="accent" :disabled="saving" :loading="loadingCpf || saving" @click="saveEdit()">
            <v-icon>{{ this.translate("system.button.save_manage.icon") }}</v-icon>
          </v-btn>
          <span>{{ this.translate("system.button.save_manage.title") }}</span>
        </v-tooltip>
      </v-speed-dial>

      <v-btn
        v-if="view === 3 && this.$auth.user().empresa_id == this.editedItem.empresa_id"
        color="primary"
        dark
        fab
        :disabled="saving"
        :loading="loadingCpf || saving"
        @click="save()"
      >
        <v-icon>{{ this.translate("system.button.done.icon") }}</v-icon>
      </v-btn>

      <v-btn fab small @click="close">
        <v-icon>{{ this.translate("system.button.close.icon") }}</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<style scoped>
tr td:last-child {
  min-width: 130px;
}

.fab-container {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 10;
}
</style>

<script>
import crud from "./../../mixin/crud";
import acl from "./../../mixin/acl";
import contatos from "../details/Contato";
import empresas from "../details/Empresa";
import PessoaDependente from "../details/PessoaDependente";
import PDate from "../shared/PDate";
import PExportLcdpr from "../shared/PExportLCDPR";
import PExportCaixaGeral from "../shared/PExportCaixaGeral";
import PRelatorioConferencia from "../shared/PRelatorioConferencia";
import PCpfCnpj from "../shared/PCpfCnpj";
import Helper from "./../../classes/helper";

export default {
  mixins: [crud, acl],
  components: {
    contatos,
    empresas,
    PessoaDependente,
    PDate,
    PExportLcdpr,
    PExportCaixaGeral,
    PRelatorioConferencia,
    PCpfCnpj,
  },
  data: () => ({
    entity: "pessoa",
    tab: null,
    beforeCpf: null,
    fab: null,
    cidades: [],
    paises: [],
    conjuges: [],
    empresas: [],
    rgie_label: "RG",
    name_label: "Nome",
    cpf_cnpj: "",
    selectedFile: null,
    changeCompany: {
      dialog: false,
      empresas: [],
    },
    loadingCpf: false,
    dialog_log: false,
    dialog_settings: false,
    dialogLogImportacao: false,
    log_file: "",
    dbk_file: "",
    file_import_error: "",
    checkboxes: {},
  }),
  created() {
    this.initialize();
    this.editedItem = {
      ativo: true,
      empresa_id: this.$auth.user().empresa_id,
      endereco_brasil: true,
      possui_conjuge: false,
      cpf_cnpj: "",
    };
    this.defaultItem = {
      ativo: true,
      empresa_id: this.$auth.user().empresa_id,
      endereco_brasil: true,
      possui_conjuge: false,
      cpf_cnpj: "",
    };
  },
  methods: {
    openDialogDBK(item) {
      this.$store.commit("loader/change_dialog", true);
      this.$http
        .get(`export/dbk`, {
          params: {
            condominio_id: item.id,
            is_consolidado: true,
          },
        })
        .then((res) => {
          this.$store.commit("loader/change_dialog", false);
          this.log_file = res.body.log_file;
          this.dbk_file = res.body.dbk_file;
          if (this.log_file) this.dialog_log = true;
          else this.downloadDBK();
        })
        .catch((error) => {
          // console.log(error);
          this.$store.commit("loader/change_dialog", false);
          this.$store.commit("snackbar/change_values", {
            text: error.body.message,
            color: "error",
            dialog: true,
          });
        });
    },
    openDialogSettings() {
      this.checkboxes.bem_direito = true;
      this.checkboxes.bem_atividade_rural = true;
      this.checkboxes.divida_onus_real = true;
      this.checkboxes.divida_atividade_rural = true;
      this.checkboxes.rendimento_tributavel_pj = true;
      this.checkboxes.rendimento_isento_nao_tributavel = true;
      this.checkboxes.rendimento_tributacao_exclusiva = true;
      this.checkboxes.pagamento_efetuado = true;
      this.checkboxes.movimentacao_financeira = true;

      this.dialog_settings = true;
    },
    viewLOG() {
      window.open(process.env.API + `validacoes/${this.log_file}`, "_blank");
      this.dialog = false;
    },
    downloadDBK() {
      window.open(process.env.API + `dbks/${this.dbk_file}`, "_blank");
      this.dialog_log = false;
    },
    updateValue(value) {
      this.inputValue = value.replace(/[^0-9]/g, "").substring(0, 14);
    },
    showMenu(event, item) {
      this.$store.commit("loader/change_dialog", true);
      this.$http
        .get(`api/get_condominios_pessoa/${item.id}`)
        .then((response) => {
          let participacoesArray = response.body.map((objeto) => objeto.id_texto);
          let participacoes = participacoesArray.join(", ");

          const textarea = document.createElement("textarea");
          textarea.value = participacoes;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);

          this.$store.commit("snackbar/change_values", {
            text: participacoes,
            color: "info",
            dialog: true,
            timeout: 10000,
          });
          this.$store.commit("loader/change_dialog", false);
        })
        .catch((error) => {
          this.$store.commit("loader/change_dialog", false);
        });
    },
    clickCaixaGeral(pessoa_id, nome) {
      this.$refs.caixaGeral.editedItem.pessoa_id = pessoa_id;
      this.$refs.caixaGeral.editedItem.nome = nome;
      this.$store.commit("loader/change_dialog", true);
      // pega todos os condominios da pessoa para o usuário escolher
      this.$http.get(`api/get_condominios_pessoa/${pessoa_id}`).then((res) => {
        this.$refs.caixaGeral.editedItem.condominios_ids = [];
        this.$refs.caixaGeral.condominiosPessoa = res.body;
        this.$refs.caixaGeral.condominiosPessoa.push({
          id: "total",
          id_texto: "Total",
        });
        this.$refs.caixaGeral.dialogExportCaixaGeral = true;
        this.$store.commit("loader/change_dialog", false);
      });
    },
    clickConferencia(pessoa_id, nome) {
      this.$refs.conferencia.editedItem.pessoa_id = pessoa_id;
      this.$refs.conferencia.editedItem.nome = nome;
      this.$store.commit("loader/change_dialog", true);
      // pega todos os condominios da pessoa para o usuário escolher
      this.$http.get(`api/get_condominios_pessoa/${pessoa_id}`).then((res) => {
        this.$refs.conferencia.editedItem.condominios_ids = [];
        this.$refs.conferencia.condominiosPessoa = res.body;
        this.$refs.conferencia.dialogRelatorioConferencia = true;
        this.$store.commit("loader/change_dialog", false);
      });
    },

    clear_conjuge() {
      if (!this.editedItem.possui_conjuge) this.editedItem.pessoa_id = null;
    },

    clickLCDPR(pessoa_id, nome) {
      this.$refs.lcdpr.editedItem.pessoa_id = pessoa_id;
      this.$refs.lcdpr.editedItem.nome = nome;
      this.$store.commit("loader/change_dialog", true);
      // pega todos os condominios da pessoa para o usuário escolher
      this.$http.get(`api/get_condominios_pessoa/${pessoa_id}`).then((res) => {
        console.log("res.body", res.body);
        this.$refs.lcdpr.condominiosPessoa = res.body;
        this.$refs.lcdpr.dialogExportLCDPR = true;
        this.$store.commit("loader/change_dialog", false);
      });
    },
    downloadItem(item, event) {
      this.$store.commit("loader/change_dialog", true);
      this.$http
        .get(`report/declaracao_ajuste/${item.id}/1`, {
          responseType: "arraybuffer",
        })
        .then(
          (res) => {
            let blob = new Blob([res.data], {
              type: res.headers.get("content-type"),
            });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = item.id_texto + ".pdf";
            link.click();
            this.$store.commit("loader/change_dialog", false);
          },
          () => this.$store.commit("loader/change_dialog", false)
        );
    },
    isUnlocked(item) {
      let empresa = item.empresas.find((a) => a.empresa_id === this.$auth.user().empresa_id);

      if (empresa) {
        return empresa.ativo;
      }
    },
    isBlocked() {
      return this.view === 3 && !this.editedItem.isOwner;
    },
    liberaAcesso(item) {
      let empresaLiberada = item.empresas.find(
        (a) => a.empresa_id === this.$auth.user().empresa_id
      );
      if (
        confirm(
          `Tem certeza de que deseja ${
            empresaLiberada.ativo ? "bloquear" : "liberar"
          } o acesso ao compartilhamento de informações desta pessoa?`
        )
      ) {
        empresaLiberada.ativo = !empresaLiberada.ativo;
        item.empresas.find((a) => a.empresa_id === this.$auth.user().empresa_id).ativo =
          empresaLiberada.ativo;

        this.editValue("pessoa_empresa", empresaLiberada.id, empresaLiberada);
      }
    },
    labels: function () {
      setTimeout(() => {
        switch (this.editedItem.tipo) {
          case 1:
            this.name_label = "Nome";
            this.rgie_label = "RG";
            break;
          case 2:
            this.name_label = "Razão Social";
            this.rgie_label = "IE";
            break;
        }
      }, 10);
    },
    toogleCompanyDialog(item) {
      Object.assign(this.editedItem, JSON.parse(JSON.stringify(item)));
      this.changeCompany.dialog = !this.changeCompany.dialog;
    },
    confirmChangeCompany(item) {
      if (this.editedItem.empresa_id == this.$auth.user().empresa_id) {
        alert(`A empresa selecionada já é responsável pela Pessoa "${this.editedItem.id_texto}".`);
        return;
      }

      this.$store.commit("loader/change_dialog", true);
      this.$http.post(`api/pessoa/change_company`, this.editedItem).then((res) => {
        this.$store.commit("loader/change_dialog", false);
        this.changeCompany.dialog = false;

        alert("Registro transferido com sucesso! A página será atualizada.");
        location.reload();

        // setTimeout(function() {
        //   alert(
        //     "Registro transferido com sucesso! A página será atualizada."
        //   );
        //   location.reload();
        // }, 10);

        // this.$store.commit("snackbar/change_values", {
        //   text:
        //     "Registro transferido com sucesso!",
        //   color: "success",
        //   dialog: true
        // });
      });
    },
    beforeSave() {
      this.editedItem.cpf_cnpj = this.editedItem.cpf_cnpj
        .replaceAll(".", "")
        .replaceAll("-", "")
        .replaceAll("/", "");
    },
    afterInitialize() {
      this.items = [...this.items, ...this.resBody.conexoes];
      this.conjuges = JSON.parse(JSON.stringify(this.items));
      this.items.map((item) => (item.isOwner = this.$auth.user().empresa_id == item.empresa_id));
      this.paises = this.resBody.paises;
      this.empresas = this.resBody.empresas;

      this.changeCompany.empresas = Object.assign(this.empresas);
      this.changeCompany.empresas.splice(
        this.changeCompany.empresas.findIndex(
          (company) => company.id_texto === "Empresa de Jackson"
        ),
        1
      );
      this.changeCompany.empresas.splice(
        this.changeCompany.empresas.findIndex(
          (company) => company.id_texto === "Empresa de Rafael"
        ),
        1
      );
      this.cidades = this.resBody.cidades;
      this.cidades.map(function (value) {
        value.id_texto = value.id_texto + " - " + value.uf;
      });
    },
    afterEdit() {
      this.beforeCpf = this.editedItem["cpf_cnpj"];
      // Verificar depois se faz sentido o conjugues tirar o item no afterEdit
      let index = this.conjuges.findIndex((item) => item.id === this.editedItem.id);
      if (index !== -1) this.conjuges.splice(index, 1);
    },
    afterSave() {
      this.items.map((item) => (item.isOwner = this.$auth.user().empresa_id == item.empresa_id));
    },
    afterClose() {
      this.beforeCpf = null;
    },
    checkCpfExists() {
      const cpf = (this.editedItem.cpf_cnpj || '').replace(/[.\-\/]/g, '')
      if (!cpf) return
      const pessoaId = this.editedItem.id || 0
      this.loadingCpf = true
      this.$http.get(`api/existsCpf/${cpf}/${pessoaId}`).then(res => {
        let cpfExistsError = res.body || null
        if (cpfExistsError)
          {
          this.editedItem.cpf_cnpj = ""
          alert("CPF " + cpfExistsError.cpf_cnpj + " já cadastrado na empresa: " + cpfExistsError.empresa.id_texto)
          }
      }).finally(() => {
        this.loadingCpf = false
      });
    },
    visualizeFileImportError() {
      window.open(process.env.API + `logs_importacao/${this.file_import_error}`, "_blank");
      this.$store.commit("loader/change_dialog", false);
    },
    onFileChanged(e) {
      this.selectedFile = e.target.files[0];
    },
    importDBK(prosseguir) {
      let formData = new FormData();
      this.$store.commit("loader/change_dialog", true);
      formData.append("dbk_file", this.selectedFile);
      formData.append("prosseguirImportacao", prosseguir);
      formData.append("content", this.checkboxes);

      Object.keys(this.checkboxes).map((key) => [key, formData.append(key, this.checkboxes[key])]);

      console.log("check", this.checkboxes);

      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      this.$http.post(`import/dbk2026`, formData, config).then(
        (res) => {
          this.$store.commit("loader/change_dialog", false);
          this.dialogLogImportacao = false;
          // this.initialize();
          this.$store.commit("snackbar/change_values", {
            text: "Registro importado com sucesso!",
            color: "success",
            dialog: true,
          });
          setTimeout(() => {
            location.reload();
          }, 3000);
        },
        (err) => {
          this.$store.commit("loader/change_dialog", false);

          // Verificar se o erro é de empresa diferente
          if (err.body && err.body.error_type === "empresa_diferente") {
            const empresaProprietaria = err.body.empresa_proprietaria || "não identificada";
            const nomeContribuinte = err.body.nome_contribuinte || "";
            const cpfContribuinte = err.body.cpf_contribuinte || "";

            const mensagem = `O contribuinte ${nomeContribuinte} (CPF: ${cpfContribuinte}) pertence à contabilidade: "${empresaProprietaria}".\n\nNão é possível importar DBKs de outra contabilidade.`;

            alert(mensagem);

            this.$store.commit("snackbar/change_values", {
              text: `Contribuinte pertence à contabilidade: ${empresaProprietaria}`,
              color: "error",
              dialog: true,
              timeout: 10000,
            });

            this.dialog_settings = false;
            return;
          }

          // Tratamento de outros erros
          this.file_import_error = err.body.error;

          if (err.body.success) {
            this.$store.commit("snackbar/change_values", {
              text: "Registro importado com sucesso!",
              color: "success",
              dialog: true,
            });
            this.dialogLogImportacao = false;
            setTimeout(() => {
              location.reload();
            }, 3000);
          } else {
            this.dialogLogImportacao = true;
            this.$store.commit("snackbar/change_values", {
              text: "Ocorreu um erro na importação do DBK",
              color: "error",
              dialog: true,
            });
          }
        }
      );
    },
  },
  computed: {
    // maskedValue() {
    //   const value = this.inputValue;
    //   if (!value) return "";
    //   const regex = /(\d{2})(\d{2})(\d{2})(\d{2})(\d{2}) - (\d{2})/;
    //   return value.replace(regex, "$1.$2.$3.$4.$5 - $6");
    // },
    headers: function () {
      return [
        {
          text: this.translate("table." + this.entity + ".field.id_texto"),
          value: "id_texto",
        },
        {
          text: this.translate("table." + this.entity + ".field.nome_abreviado"),
          value: "nome_abreviado",
        },
        {
          text: this.translate("table." + this.entity + ".field.cpf_cnpj"),
          value: "cpf_cnpj",
        },
        {
          text: this.translate("table." + this.entity + ".field.rg_ie"),
          value: "rg_ie",
        },
        {
          text: this.translate("table." + this.entity + ".field.ativo"),
          value: "ativo",
          width: "5%",
        },
        {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/crud/Pessoa.vue